import { Button, Col, Row, Tabs } from 'antd'
import { PlusOutlined } from '@ant-design/icons';
import React from 'react'
import { useParams } from 'react-router-dom';
import { PricingAPI } from '../../../../controller/PricingAPI';
import { hasPermission } from '../../../../navigation';
import TodoAgenda from './components/TodoAgenda';
import TodoFormModal from './components/TodoFormModal';
import TodoListPaneContent from './components/TodoListPaneContent';
import { TAB_ALL, TAB_MINE, historyScope, notifyTodosChanged, tabsFor } from './todoHelpers';

function TodoPage() {
    // 信件裡的深層連結 (/todos/:todoId)。沒有這個參數時是正常進頁
    const { todoId } = useParams();
    const isAdmin = hasPermission(PricingAPI.auth.getPermissions(), '*');
    const [refreshTime, setRefreshTime] = React.useState(Date.now());
    // null：關閉；{ todo: null }：新增；{ todo }：編輯
    const [form, setForm] = React.useState(null);

    // 受控頁籤：切換頁籤時要一併重抓
    const [activeTab, setActiveTab] = React.useState(TAB_MINE);
    // 連結指向的工作一定在「待我處理」，落在別的頁籤上使用者會以為連結壞了。
    // 用 effect 而不是把頁籤鎖死：頁面已開著時再點信件連結 (只換 hash 不重掛)
    // 也要切回來，但使用者之後仍可自己換頁籤
    // 換連結時也要重抓：新那一筆未必在上次抓回來的資料裡。首次進頁不用 -
    // TodoAgenda 掛載時本來就會抓，多遞增一次只會多打一次 API
    const previousTodoId = React.useRef(todoId);
    React.useEffect(() => {
        if (todoId) {
            setActiveTab(TAB_MINE);
        }
        if (todoId && previousTodoId.current !== todoId) {
            setRefreshTime(Date.now());
        }
        previousTodoId.current = todoId;
    }, [todoId]);

    const handleSaved = () => {
        setForm(null);
        setRefreshTime(Date.now());
        notifyTodosChanged();
    };

    return (
        <div>
            <Row justify="space-between" align="middle" style={{ marginBottom: 8 }}>
                <Col>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => setForm({ todo: null })}>
                        新增待辦
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Tabs
                        activeKey={activeTab}
                        onChange={(key) => {
                            setActiveTab(key);
                            setRefreshTime(Date.now());
                        }}
                    >
                        {tabsFor().map((tab) => (
                            <Tabs.TabPane tab={tab.label} key={tab.key}>
                                {tab.key === TAB_MINE ? (
                                    <TodoAgenda
                                        refreshTime={refreshTime}
                                        onEdit={(todo) => setForm({ todo })}
                                        onChanged={() => setRefreshTime(Date.now())}
                                        focusId={todoId}
                                    />
                                ) : (
                                    <TodoListPaneContent
                                        key={tab.key}
                                        state={tab.key === TAB_ALL ? 'new' : tab.key}
                                        scope={tab.key === TAB_ALL ? 'all' : historyScope(isAdmin)}
                                        refreshTime={refreshTime}
                                        onChanged={() => setRefreshTime(Date.now())}
                                        onEdit={(todo) => setForm({ todo })}
                                    />
                                )}
                            </Tabs.TabPane>
                        ))}
                    </Tabs>
                </Col>
            </Row>
            <TodoFormModal
                open={!!form}
                todo={form ? form.todo : null}
                onClose={() => setForm(null)}
                onSaved={handleSaved}
            />
        </div>
    )
}

export default TodoPage
